import { useRef, useState, useEffect } from 'react'
import { Tooltip } from 'antd'

const EllipsisTooltip = ({ text, className = '', width = '100%' }) => {
  const ref = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const el = ref.current

    if (el) {
      // console.log(`${text}: ${el.scrollWidth} > ${el.clientWidth}`)
      setIsTruncated(el.scrollWidth > el.clientWidth)
    }
  }, [text])

  const content = (
    <div
      ref={ref}
      style={{
        width,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordBreak: 'keep-all',
      }}
      className={className}
    >
      {text}
    </div>
  )

  return isTruncated ? <Tooltip title={text}>{content}</Tooltip> : content
}

export default EllipsisTooltip
